module.exports = function() {
  return new Worker(__webpack_public_path__ + "7f59c4397230d3963d3f.worker.js");
};